import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GuestRoutes } from "@app/GuestRoutes";
import { RegisteredRoutes } from "@app/RegisteredRoutes";

const appRoutes: Routes = GuestRoutes.concat(RegisteredRoutes);

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
    exports: [RouterModule],
    providers: []
})

export class AppRoutingModule {}
